module.exports = __webpack_public_path__ + "media/images/icon-answer@3x-873b864c7f3eac82d25acb229f074774.png";